import { useNavigate } from "react-router";

import { HowToPlay } from "./HowToPlay.js";
import { remember } from "../services/authService.js";

/**
 * `/how-to-play` — the walkthrough on its own route, phase 24.
 *
 * Reachable from the menu, so a profile that dismissed it can run it again. That
 * is what makes dismissing it safe: *"dismissed once, gone for good"* is only a
 * reasonable rule if there is a way back.
 *
 * ⚠️ **Finishing here also records it**, even for somebody who had already seen
 * it. Writing a value that is already `true` costs one request and removes the
 * case where a profile watches it from the menu, never plays, and is shown it
 * again at their first game.
 */
export function HowToPlayPage() {
  const navigate = useNavigate();

  const done = () => {
    // Best effort, and deliberately so: the walkthrough is over either way, and
    // failing to record it must not strand somebody on a tutorial they have
    // finished. The cost of a lost write is being shown it once more.
    void remember({ seen_how_to_play: true }).catch(() => undefined);
    void navigate("/");
  };

  return (
    <main className="min-h-full">
      <HowToPlay onDone={done} onOpenRules={() => void navigate("/rules")} />
    </main>
  );
}
